import React, { useRef, useState } from 'react';
import { Schema } from '../schema';
import {
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    Button,
  } from 'reactstrap';

interface ColumnSelectorProps {
    position: number;
    selection: string;
    schema: Schema;
    onSelected:(colName:string) => void;
    onClear:() => void;
}

const DEFAULT_SELECTION = 'Select Column';

export default (props: ColumnSelectorProps) => {
    
    const onItemSelected = (e) => {
      if (!props.onSelected) return;
      props.onSelected(e.target.value);
    };
    
    const clear = () => {
        if (!props.onClear) return;
        props.onClear();
    };

    const filterInputRef = useRef<HTMLInputElement>(null);
    const [search,setSearch] = useState('');

    const handleSearch = (search: string) => {
        setSearch(search.toLowerCase());
    }

    const selected = props.selection || DEFAULT_SELECTION;
   
    return (
      <UncontrolledDropdown direction="down">
        <DropdownToggle
          aria-haspopup
          color="default"
          data-toggle="dropdown"
          nav
          onClick={() => {
            setTimeout(() => {
              filterInputRef?.current?.focus();
            }, 10);
            setSearch('');
          }}
        >
          <span
            className={
              selected === DEFAULT_SELECTION
                ? 'tpicap-mapeditor-col unmapped'
                : 'tpicap-mapeditor-col mapped'
            }
          >
            {selected}
          </span>
        </DropdownToggle>
        <DropdownMenu className="tpicap-dropdown-menu" container="body">
          {selected !== DEFAULT_SELECTION && (
            <div className="header-container">
              <Button onClick={()=>clear()}>Clear Selection</Button>
            </div>
          )}
          <DropdownItem header>Filter</DropdownItem>
          <div className="filter-container">
            <input
              className="form-control"
              type="text"
              ref={filterInputRef}
              onChange={(e) => {handleSearch(e.target.value);}}
            ></input>
          </div>
          <div className="menu-container">
            {props.schema.filter((col) => {
              if (col.nomap) return false;
              if (col.name === props.selection) return false;
              if (!search) return col;
              return col.name.toLowerCase().indexOf(search) >= 0;
            }).map((column, i) => (
              <DropdownItem
                //eslint-disable-next-line
                key={i}
                onClick={onItemSelected}
                value={column.name}
              >
                {column.name}
              </DropdownItem>
            ))}
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  
}
